import React from "react";
import { cn } from "@/lib/helpers/cn";

export function MenuSection({ title, children, className = "" }) {
  return (
    <div
      role="menu"
      className={cn(
        "tw:flex tw:flex-col tw:gap-1",
        "tw:border-b-1 tw:border-stroke-tertiary tw:pb-4",
        className,
      )}
    >
      <span className="tw:mb-1 tw:text-xs tw:leading-[1.25] tw:tracking-[1.2px] tw:text-text-tertiary tw:capitalize">
        {title}
      </span>
      {children}
    </div>
  );
}
